import { Helmet } from "@dr.pogodin/react-helmet";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import vars from "utils/vars";

const MetaTags = (props) => {
	const { pathname } = useLocation();
	const { i18n } = useTranslation();
	const language = i18n.language?.toLowerCase()?.split("-")?.[0];

	// postcss-rtlcss scopes the rtl declarations under [dir], so the attribute has to
	// exist for those overrides to resolve. Setting it outside of Helmet keeps it from
	// being stripped when another mounted Helmet renders without htmlAttributes.
	useEffect(() => {
		const html = document.documentElement;

		if (language) html.setAttribute("lang", language);
		// FIXME: switch to i18n.dir(language) in case handling rtl layout
		html.setAttribute("dir", "ltr");
	}, [language]);

	const {
		pageTitle = "",
		description = vars.app.description,
		keywords = vars.app.keywords,
		title = vars.app.name,
		themeColor = vars.app.themeColor || "",
		cover = "",
		children,
	} = props;

	return (
		<>
			<Helmet prioritizeSeoTags>
				{/* Start: Meta Tags */}
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
				<meta name="description" content={description} key="description" />
				<meta name="keywords" content={keywords} key="keywords" />
				<meta property="type" content="website" key="type" />
				<meta property="url" content={pathname} key="url" />
				<meta name="twitter:card" content="summary_large_image" key="twitter:card" />
				<meta name="twitter:title" content={title} key="twitter:title" />
				<meta name="twitter:description" content={description} key="twitter:description" />
				<meta name="twitter:image" content={cover} key="twitter:image" />
				<meta property="og:url" content={pathname} key="og:url" />
				<meta property="og:type" content="website" key="og:type" />
				<meta property="og:site_name" content={title} key="og:site_name" />
				<meta property="og:title" content={title} key="og:title" />
				<meta property="og:description" content={description} key="og:description" />
				<meta property="og:image" content={cover} key="og:image" />
				<meta property="og:image:url" content={cover} key="og:image:url" />
				<meta property="og:image:secure_url" content={cover} key="og:image:secure_url" />
				<meta property="og:image:type" content="image/*" key="og:image:type" />
				<meta property="og:image:width" content="400" key="og:image:width" />
				<meta property="og:image:height" content="300" key="og:image:height" />
				<meta name="apple-mobile-web-app-title" content={title} />
				<meta name="application-name" content={title} />
				<meta name="msapplication-TileColor" content={themeColor} />
				<meta name="theme-color" content={themeColor} />
				{/* End: Meta Tags */}

				{/* Start: Title */}
				<title>{`${
					pageTitle && `${pageTitle.charAt(0).toUpperCase()}${pageTitle.slice(1)} |`
				} ${title}`}</title>
				{/* End: Title */}

				{children}
			</Helmet>
		</>
	);
};

export default memo(MetaTags);
